import Direction from '../../../../shared/types/enums/direction';
import Screen from '@screen';
import styled from 'styled-components';
import DeviceConfig from '@devices/config';

const ListAnimationContainer = styled.div<{
  direction?: Direction;
  duration: number;
  index: number;
  offset: number;
}>`
  display: flex;
  flex-direction: ${(props) =>
    props.direction === Direction.HORIZONTAL ? 'row' : 'column'};
  transform: translate(
    ${(props) => {
      const displacementX =
        props.direction === Direction.HORIZONTAL
          ? -props.offset * props.index * Screen.widthRatio
          : 0;
      const displacementY =
        props.direction === Direction.VERTICAL
          ? -props.offset * props.index * Screen.widthRatio
          : 0;
      return `${displacementX}px,${displacementY}px`;
    }}
  );
  transition: ${(props) =>
    DeviceConfig.capabilities.disableAnimations
      ? 'none'
      : `transform ${props.duration}s linear`};
`;

export default ListAnimationContainer;
